/**
 * Billing Readiness feature auto-registration and exports
 *
 * This module automatically registers the billing readiness feature when imported,
 * providing hierarchical readiness checks for claim submission.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { billingReadinessFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(billingReadinessFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';

// Export components
export { default as BillingSettingsPage } from './components/BillingSettingsPage';
export { BillingSetupWizard } from './components/BillingSetupWizard';
